import React from 'react'
import Link from 'gatsby-link'

import styles from './PageTitle.module.css'

const PageTitle = ({ children }) => {
  return (
    <h1 style={{ margin: 0 }} className={styles.title}>
      <Link to="/" className={styles.link}>
        {children}
      </Link>
    </h1>
  )
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/header/PageTitle.js